import * as R from 'ramda';
import { Endpoints } from '../../../../core/api/endpoints';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../../../../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../../../../core/api/module';
import { ActionType } from '../../../../core/redux/actionType';
import { removeAction } from '../module';


const KEY_ACTION = ActionType.DeleteDevPlanActionRequest;
const ACTIONS    = [
  ActionType.DeleteDevPlanActionRequest,
  ActionType.DeleteDevPlanActionResponse,
  ActionType.DeleteDevPlanActionError,
];


type Payload = undefined;
type Meta = { projectId: number; actionId: number; devPlanId: number; };


/**
 * Dispatch this action to delete a dev plan item's action
 */
export const deleteDevPlanActionAction = (projectId: number, devPlanId: number, actionId: number) => 
makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.DeleteDevPlanAction,
  headers:  { 'content-type': 'application/json' },
  body:     state => JSON.stringify({
    devActionId: actionId,
    projectId: projectId,
    participantId: state.auth.currentUser?.personId ?? 0,
    languageId: state.locale.lang.languageId,
  }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId, actionId, devPlanId }),
  bailout:  state => !!getLoading(state, KEY_ACTION, actionId),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION, action.meta.actionId);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, action.meta.actionId);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, action.meta.actionId);

  // Remove the offending action from app state now that the API says it was successfully deleted
  return R.assocPath( // Remove from actions mapped by dev plan
    ['devPlan', 'actionsByItemId'],
    removeAction(action.meta.devPlanId, action.meta.actionId, successState.devPlan?.actionsByItemId),
    successState,
  );
};


export const deleteDevPlanActionReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
